module.exports = __webpack_public_path__ + "img/collaborate@2x.ec105aaf.webp";